import React from 'react'  
import PropTypes from 'prop-types'
import axios from 'axios';
import Card from './Card'

class RelatedConcerts extends React.Component {
  constructor () {
    super();
    this.state = {
      concerts: []
    };

  }
  componentWillMount () {
    axios.get( '/api/artists/' + this.props.artist + '/related-concerts' )
    .then(response => {
      this.setState({ concerts: response.data });
    })
    .catch(error => {
      console.error(error);
    });
  }
  render () {
    return (
      this.state.concerts.length > 0 &&
        <div>
            <div style={{paddingLeft: 0, paddingRight: 0}}  className="col-xs-12 col-sm-12 col-md-12 sk_subtitle-container related-concerts">
              <h3 className="sk_headline--level3">
                {this.props.title}
              </h3>
            </div>
          <div className="col-xs-12 col-md-offset-1 col-md-10">
            {this.state.concerts.map((concert, index) =>
              <div key={concert.id} 
                  style={{padding: 5}}
                  className={"col-xs-12 col-sm-4 " + 
                              (index == 0 && this.state.concerts.length == 2 ? 'col-sm-offset-2' : '') +
                              (index == 0 && this.state.concerts.length == 1 ? 'col-sm-offset-4' : '')
                            }>
                <Card image={concert.img}
                      imageLink={`/artists/${concert.a_slug}`}
                      category={concert.date_de}
                      headline={`${concert.a_name} (${concert.a_cc})`}
                      headlineLink={`/artists/${concert.a_slug}`}
                      subheadline={`${concert.l_name}, ${concert.c_name}`}
                      subheadlineLink={`/${concert.l_slug}`} />
              </div>
            )}
          </div>
        </div>
    );
  }
}

export default RelatedConcerts;